import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
} from 'reactstrap';
import Form from './form';
import {
  getSurvey,
  saveSurvey,
} from '../../../../redux/actions/materiaPeriodoActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../../helpers/notification';
import LoadingSpinner from '../../../../shared/components/LoadingSpinner';
import debounce from '../../../../helpers/debounce';

class SurveyContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      encuesta: {
        id: 0,
        spreadsheetId: '',
        sheetName: '',
        emailColumn: '',
        activa: true,
        encuestaMateriaAlumnos: [],
      },
      loading: false,
      filterValue: '',
      sortColumn: 'apellido',
      sortType: 'desc',
    };

    this.debouncedAutoSaveScore = debounce(this.autoSaveScore, 500);
  }

  componentDidMount() {
    const { id } = this.props;
    this.fetchCurrentRecord(id);
  }

  fetchCurrentRecord = (id) => {
    this.setState({ loading: true });

    if (!id) {
      const { encuesta = {} } = this.state;
      this.setState({
        loading: false,
        encuesta: {
          ...encuesta,
          id: 0,
          spreadsheetId: '',
          sheetName: '',
          emailColumn: '',
          activa: true,
          encuestaMateriaAlumnos: [],
        },
      });

      return;
    }

    getSurvey({
      id,
      onSuccess: (encuesta) => {
        const { createdAt } = encuesta;
        this.setState({
          loading: false,
          encuesta: {
            ...encuesta,
            ...{
              createdAt: createdAt.split('T')[0],
            },
          },
        });
      },
      onError: (error) => {
        this.setState({ loading: false });

        if (error && error.status === 404) {
          createErrorMessage('La encuesta de clase no existe');
        } else {
          createErrorMessage('Error al intentar cargar los datos de la encuesta');
        }
      },
    });
  }

  handleSubmit = (values) => {
    if (!values) return;

    this.setState({ loading: true });

    const {
      id,
      materiaPeriodoId,
      sheetName,
      emailColumn,
      spreadsheetId,
      activa,
    } = values;

    saveSurvey({
      paylaod: {
        id,
        materiaPeriodoId,
        sheetName,
        emailColumn,
        spreadsheetId,
        activa,
      },
      onSuccess: (encuesta) => {
        this.setState({ loading: false });

        this.fetchCurrentRecord(encuesta.id);
        createSuccessMessage('Encuesta guardada exitosamente');
      },
      onError: (error) => {
        this.setState({ loading: false });

        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la encuesta');
        }
      },
    });
  }

  handleOnBack = () => {
    const { onHideForm } = this.props;
    onHideForm();
  }

  handleChangeText = ({
    name,
    target,
    numeroDocumento,
  }) => {
    const value = target.type === 'number'
      ? Number(target.value)
      : `${target.value}`.trim();

    if (numeroDocumento) {
      const { encuesta } = this.state;
      const items = encuesta[name];

      const newArray = [...items];
      const index = newArray.findIndex(item => item.numeroDocumento === numeroDocumento);

      newArray[index] = {
        ...newArray[index],
        ...{
          [target.name.split('.')[1]]: value,
        },
      };

      this.setState({
        encuesta: {
          ...encuesta,
          [name]: newArray,
        },
      });

      this.debouncedAutoSaveScore(newArray[index]);

      return;
    }

    this.setState(prev => ({
      encuesta: {
        ...prev.encuesta,
        ...{
          [target.name]: value,
        },
      },
    }));
  };

  handleChangeSelect = ({ option, name }) => {
    const { encuesta } = this.state;

    const newState = {
      ...encuesta,
      [name]: option,
    };

    if (option.value === 2) {
      newState.puntajeTotal = 1;
      newState.porcentajePesoMateria = '';
    }

    this.setState({ encuesta: newState });
  };

  handleSort = ({ sortColumn, sortType }) => {
    this.setState({
      sortColumn,
      sortType: sortType === 'desc' ? 'asc' : 'desc',
    });
  };

  handleFilterChangeText = ({ target: { value } }) => {
    this.setState({ filterValue: value });
  };

  handleChangeChecked = (activa) => {
    const { encuesta } = this.state;

    const newState = {
      ...encuesta,
      activa,
    };

    this.setState({ encuesta: newState });
  };

  transformText = (value = '') => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  getEncuestaMateriaAlumnos = () => {
    const {
      filterValue = '',
      sortColumn,
      sortType,
      encuesta: { encuestaMateriaAlumnos = [] },
    } = this.state;

    const filter = this.transformText(filterValue);

    const result = encuestaMateriaAlumnos
      .filter(tma => (
        this.transformText(tma.numeroDocumento).includes(filter)
        || this.transformText(tma.nombre).includes(filter)
        || this.transformText(tma.apellido).includes(filter)
      ))
      .sort((a, b) => (
        sortType !== 'asc' ? a[sortColumn].localeCompare(b[sortColumn]) : b[sortColumn].localeCompare(a[sortColumn])
      ));

    return result;
  };

  render() {
    const {
      id,
      materiaPeriodoId,
    } = this.props;

    const {
      encuesta,
      loading,
      filterValue,
      sortColumn,
      sortType,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nueva'} encuesta
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              encuesta
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {
              loading ? <LoadingSpinner />
                : (
                  <Form
                    {...encuesta}
                    materiaPeriodoId={materiaPeriodoId}
                    encuestaMateriaAlumnos={this.getEncuestaMateriaAlumnos()}
                    filterValue={filterValue}
                    onSubmit={this.handleSubmit}
                    onBack={this.handleOnBack}
                    loading={loading}
                    initialValues={encuesta}
                    sortColumn={sortColumn}
                    sortType={sortType}

                    handleChangeText={this.handleChangeText}
                    handleChangeChecked={this.handleChangeChecked}
                    onChangeSelect={this.handleChangeSelect}
                    handleSort={this.handleSort}
                    handleFilterChangeText={this.handleFilterChangeText}

                    showSpinner={this.showSpinner}
                    enableReinitialize
                  />
                )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

SurveyContainer.propTypes = {
  id: PropTypes.number.isRequired,
  materiaPeriodoId: PropTypes.number.isRequired,
  onHideForm: PropTypes.func.isRequired,
};

export default SurveyContainer;
